import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const CHECKOUT_URL = 'https://librofy-store.myshopify.com/checkouts/cn/hWNC5cq5IC2Px4bOYyL7z9rW/es-ar?_r=AQABL_iBycLbHlaKuWM5jNWfPwGKe0H7Sbmx0hOsmBtBg3k';
const items = ['📘 TOMO 1: Adiós a la Hinchazón — El Reset Digestivo en 72 Hs', '📗 TOMO 2: Paz en Dos Minutos — El Reset del Sistema Nervioso', '🟧 TOMO 3: Energía Real — El Reset de Vitalidad Sin Estimulantes', '✅ Checklist de 72hs imprimible', '✅ Rastreador de síntomas semanal', '✅ Guía de sustituciones rápidas'];
export function TomoDetails() {
  return <section className="py-12 md:py-16 bg-brand-cream" data-id="element-341">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-342">
        <FadeIn data-id="element-343">
          <div className="bg-white border border-brand-verifiedGreen/40 rounded-3xl shadow-card p-6 md:p-8" data-id="element-344">
            {/* Title */}
            <h2 className="text-2xl md:text-3xl font-extrabold text-brand-accent text-center mb-3 leading-tight" data-id="element-345">
              🔥 TODO LO QUE RECIBÍS HOY
            </h2>

            {/* Subtitle */}
            <p className="text-center font-bold text-base md:text-lg mb-6 text-brand-terracotta" data-id="element-346">
              ⚠️ Oferta activa solo mientras el contador corra
            </p>

            {/* Items list */}
            <ul className="space-y-3 mb-6" data-id="element-347">
              {items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-348">
                  <CheckCircle2 className="w-5 h-5 text-brand-verifiedGreen shrink-0 mt-0.5" data-id="element-349" />
                  <span className="text-brand-dark text-[15px] md:text-base leading-snug" data-id="element-350">
                    {item}
                  </span>
                </li>)}
            </ul>

            {/* Pricing block */}
            <div className="bg-brand-softGreen border border-brand-verifiedGreen/40 rounded-2xl p-5 text-center mb-5" data-id="element-351">
              <p className="text-brand-terracotta line-through text-lg font-medium mb-1" data-id="element-352">
                $33.000 ARS
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-353">
                <p className="text-4xl md:text-5xl font-extrabold text-brand-accent tracking-tight" data-id="element-354">
                  $19.990 ARS
                </p>
                <span className="inline-block bg-brand-terracotta text-white text-xs font-extrabold uppercase px-3 py-1.5 rounded-full tracking-wider shadow-sm" data-id="element-355">
                  50% OFF
                </span>
              </div>
            </div>

            {/* Social proof */}
            <p className="text-center text-sm text-brand-muted mb-5" data-id="element-356">
              ⚡ Más de 500 mujeres ya lo tienen. No te quedes afuera.
            </p>

            {/* CTA */}
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full text-center font-extrabold uppercase tracking-wide text-white text-lg md:text-xl px-6 py-5 rounded-full transition-transform duration-300 hover:scale-[1.02] animate-cta-pulse shadow-urgent" style={{
            backgroundColor: '#FF3B1F'
          }} data-id="element-357">
              → QUIERO MI MEGAPACK AHORA
            </a>

            {/* Disclaimer */}
            <p className="text-center text-xs text-brand-muted mt-4" data-id="element-358">
              ⏳ Este precio desaparece cuando el contador llegue a cero
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}